import React, { Component } from 'react';
import MainHeader from '../../../components/common/MainHeader';
import FooterDesktop from '../../../components/common/FooterDesktop_bhutan';
import Bagdogra_Tour_Jamnagar from '../../../components/package/Bhutan/Bagdogra_Tour_Jamnagar';
import { Helmet } from "react-helmet";

class BagdograToJamnagarPage extends Component {
    constructor() {
        super();
        this.state = {
            
            ReviewersData: [],

        }
    }


    componentDidMount() {
        window.scroll(0, 0);

        const reviewersDataList = [
            {
                Name: "Sanil Shildhankar",
                ImageName: "sunil.webp",
                AllternateText: "...",
                Location: "@Bengaluru",
                Comment: "I recently had the pleasure of booking a tour with Adorable Tours to see Bhutan, and I must say,it was one of the most amazing experiences of my life. From first contact to the end of our trip, every aspect of the tour was handled with professionalism and care.What I loved most about this company was how they listened to our needs and adjusted the itinerary to meet them, always with a smile and willingness to make us happy. They were always accessible through WhatsApp, which made communication so much easier and convenient, especially since we were traveling with our family.",
            },
            {
                Name: "Arvindan Venugopal",
                ImageName: "arvind.webp",
                AllternateText: "...",
                Location: "@Bengaluru",
                Comment: "I had a great experience visiting Bhutan with their assistance. Had a memorable recent trip to Bhutan. Recommended to try them at least once for your next trip.",
            },
            {
                Name: "Harshat Chakravarthy",
                ImageName: "Harshat-Chakravathy.webp",
                AllternateText: "...",
                Location: "@Bengaluru",
                Comment: "I had booked my Bhutan trip through them. Mr. Soumalya had helped us with all the bookings. The hotels booked were really good, the driver assigned was helpful and really humourous. We have enjoyed the trip to the most. I cannot think of anything negative that i can actually state in this review. Everything was handled exceptionally well from the start to the last day. We never had to call the agency for any follow up during the trip.",
            },
            {
                Name: "Yashika Shetty",
                ImageName: "Yashika-Shetty.webp",
                AllternateText: "...",
                Location: "@Bengaluru",
                Comment: "The overall experience with the team was very good. Mr Soumya was very prompt and well guided through the process. Mr Soumalya is supreme leader. We have really enjoyed our honeymoon trip to Bhutan. Keep up your good and valued service.",
            },
        ];



        this.setState({
           
            ReviewersData: reviewersDataList
        })
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Bhutan Package Tour from Jamnagar, Bhutan Tour Package from Jamnagar</title>
                    <meta name="description" content="We offer the best Bhutan Package Tour from Jamnagar at Best Price. For Booking CALL ☎ +91-98833-59713" />
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "http://schema.org",
                            "@type": "Product",
                            "name": "Bhutan Package Tour From Jamnagar Reviews",
                            "aggregateRating": {
                                "@type": "AggregateRating",
                                "ratingValue": "5.0",
                                "bestRating": "5",
                                "ratingCount": "410"
                            }
                        })}
                    </script>
                </Helmet>
                <MainHeader />

                <Bagdogra_Tour_Jamnagar
                    ReviewersData={this.state.ReviewersData}
                />

                <FooterDesktop />

                <div>
                    <h3 className="dropdown-item2">Bhutan Package Tour Reviews</h3>
                    <div>
                        <span className="dropdown-item2">4.8</span> <span className="dropdown-item2">Stars Rating, out of</span> <span className="dropdown-item2">5</span><br />
                        <span className="dropdown-item2">based on</span> <span className="dropdown-item2">318</span> <span className="dropdown-item2">Reviews</span>
                    </div>
                </div>
            </>
        )
    }
}

export default BagdograToJamnagarPage;